import { Card, Grid2 } from "@mui/material";
import { useEffect, useMemo } from "react";
import useUIBp from "../../../../../../Hooks/useUIBoilerplate";
import { useWorker } from "../../../../../../Hooks/useWorker";
import { getDevicesId } from "../../../../../../store/actions/devices/getDevices";
import { c365devicesListDataId } from "../../../../../Reports/Actions/getc365List";
import CollapseGrid from "../../../../../UI/GeneralPurpose/CollapseGrid";
import SlimAlert from "../../../../../UI/GeneralPurpose/SlimAlert";
import { devicePickerId } from "../../../../../UI/Specialized/DevicePicker";
import { repoPickerId } from "../../../../../UI/Specialized/RSRepositoryPicker";
import getMachineStatus, {
  rootsDataId,
  tunnelTokenId,
} from "../../Actions/getMachineStatus";
import { selectionBlockUI } from "../../RemoteSelection";
import Repository from "./Repository";

const UIText = {
  "es-CL": {
    loadingMessage1: "Cargando dispositivos",
    loadingMessage2: "Cargando repositorios",
    errorMessage: "Error al cargar repositorios",
    emptyMessage: "No hay repositorios seleccionados",
  },
  "en-US": {
    loadingMessage1: "Loading devices",
    loadingMessage2: "Loading repositories",
    errorMessage: "Error loading repositories",
    emptyMessage: "No repositories selected",
  },
};

const SelectDisplay = ({ user }) => {
  const { auth, dispatch, UI, warehouse, settings } = useUIBp();
  const { working:w1 } = useWorker(getDevicesId) ?? {};
  const { working:w2 } = useWorker(tunnelTokenId) ?? {};
  const repoPicker = UI[repoPickerId] ?? { id: "" };

  const { locale } = settings;
  const c365devices = useMemo(
    () => warehouse[c365devicesListDataId] ?? {},
    [warehouse]
  );
  const devicePicker = UI[devicePickerId] ?? { mid: "" };
  const tunnelToken = UI[tunnelTokenId] ?? "";
  const { mid } = devicePicker;
  const roots = warehouse[rootsDataId] ?? [];
  const blocked = UI[selectionBlockUI] ?? false;
  const is365device = !!c365devices[user];
  const { loadingMessage1, loadingMessage2, emptyMessage } =
    UIText[locale];

  let messages = []

  if (w1){
    messages.push(loadingMessage1);
  } else if (w2) {
    messages.push(loadingMessage2)
  } else if (repoPicker.id === "") {
    messages.push(emptyMessage);
  }

  const isTruly365device = c365devices[user] === mid;

  // console.log(warehouse[c365devicesListDataId])
  // console.log("mid", mid, "tunnelToken", tunnelToken);


  useEffect(() => {
    if (mid && !tunnelToken) {
      dispatch(
        getMachineStatus({
          ...auth,
          user,
          mid,
          is365device:isTruly365device,
        })
      );
    }
  }, [dispatch, auth, mid, user, tunnelToken, isTruly365device]);

  const rootsItems = [...roots].filter(
    (x) => (x.id === repoPicker.id || "NOID"+x.root === repoPicker.id ) && repoPicker.id !== "").map((data, idx) => (
    <Repository key={idx} {...data} />
  ));

  // console.log("rootsItems", rootsItems);
  // const rootsItems = [...roots]
  //   .sort((a, b) => sortObjByKey(a, b, "root"))
  //   .map((data, idx) => <Repository key={idx} {...data} />);
  // console.log("this got loaded")

  return (
    <CollapseGrid open={!blocked} outerProps={{ size: 12 }}>
      <Card
        {...{
          wrap: "nowrap",
          sx: {
            borderColor: "LightGray",
            borderStyle: "solid",
            borderWidth: "1px",
            boxShadow: "none",
            padding: "0.5rem",
            maxHeight: 400,
            overflowY: "auto",
            overflowX: "hidden",
            width: "100%",
          },
        }}
      >
        {(!rootsItems.length || repoPicker.id === "") && (
          <SlimAlert
            {...{
              severity: "info",
              messages: messages,
              paddingTop: 2,
              paddingBottom: 2,
            }}
          />
        )}
        <Grid2 container>{rootsItems}</Grid2>
      </Card>
    </CollapseGrid>
  );
};

export default SelectDisplay;
